export function groupBy<T>(items: T[], selector: (input: T) => string): Record<string, T[]> {
    return items.reduce((prev: Record<string, T[]>, cur: T) => {
        const key = selector(cur);
        (prev[key] = prev[key] || []).push(cur);
        return prev;
    }, {});
}